/**
 * Единственный реестр ключей запросов (AD-A5).
 *
 * Фича строит ключ отсюда, а не литералом, и инвалидирует по префиксу домена. Рядом с
 * мутацией реестр называет, какие префиксы она инвалидирует: выдача или отзыв роли трогает
 * `users` **и** `audit` — журнал обязан показать запись без ручного обновления (CAP-7).
 */
export const queryKeys = {
  me: () => ['me'] as const,
  users: {
    all: () => ['users'] as const,
    list: (params: Record<string, string | undefined>) => ['users', 'list', params] as const,
    one: (userId: string) => ['users', 'one', userId] as const,
  },
  roles: {
    all: () => ['roles'] as const,
  },
  audit: {
    all: () => ['audit'] as const,
    list: (params: Record<string, string | undefined>) => ['audit', 'list', params] as const,
  },
  // Справочник стилей — один ключ без параметров: `GET /yoga-styles` не принимает ни
  // фильтра, ни курсора и отвечает всем набором сразу.
  yogaStyles: {
    all: () => ['yoga-styles'] as const,
  },
  practices: {
    all: () => ['practices'] as const,
    list: (params: Record<string, string | undefined>) => ['practices', 'list', params] as const,
    roster: (practiceId: string, params: Record<string, string | undefined>) =>
      ['practices', 'roster', practiceId, params] as const,
  },
} as const;

/** Что инвалидирует каждая мутация. Декларация здесь, чтобы её нельзя было забыть в фиче. */
export const invalidatedBy = {
  roleChange: [queryKeys.users.all(), queryKeys.audit.all()],
} as const;
